import { QueryClient } from '@tanstack/react-query'

import './setupOnlineManager'

export const queryClient = new QueryClient({ defaultOptions: { queries: { retry: false } } })
